import { resolveComponent as _resolveComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createBlock(_component_v_tooltip, { bottom: "" }, {
    activator: _withCtx(({ on, attrs }) => [
      _createVNode(_component_v_img, _mergeProps({ contain: "" }, _toHandlers(on), {
        src: _ctx.src,
        alt: _ctx.name
      }, attrs, {
        width: `${_ctx.size}px`,
        height: `${_ctx.size}px`,
        class: "d-inline-block ma-4"
      }), null, 16, ["src", "alt", "width", "height"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_ctx.name), 1)
    ]),
    _: 1
  }))
}